// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip--VqC28","ellipsis":"ellipsis--KQpa1","icon":"icon--fuTPz","target":"target--QZTjV","valueItem":"valueItem--gqSLD"};